import { Toolbar } from '../Toolbar'
import { PropsWithChildren } from 'react'
import { Header } from '../Header'
import { SideBarAppsList } from '../../features/apps-list/SideBarAppsList'
import { BuildInfo } from '../../features/build-info/BuildInfo'
import { useMatch } from 'react-router-dom'
import { getRoute } from '@wellesley/router'
import GroupHeader from '../Header/GroupHeader'
import { HEADER_HEIGHT } from '../Header/HeaderWrapper'
import { useSwitchState } from 'hooks/useSwitchState'
import { cn } from '@wellesley/ui'

export const Layout = ({ children }: PropsWithChildren) => {
  const isGroupProfile = !!useMatch(getRoute('/g/:groupname'))
  const [isSidebarOpen, , , onToggleSidebar] = useSwitchState(true)

  return (
    <div>
      {isGroupProfile ? (
        <GroupHeader onToggleSidebar={onToggleSidebar} />
      ) : (
        <Header onToggleSidebar={onToggleSidebar} />
      )}
      <BuildInfo />
      <div className="flex w-full">
        <Toolbar isVisible={isSidebarOpen} />
        <div className="flex w-full flex-row rounded-s-2xl bg-slate-100">
          <SideBarAppsList isVisible={isSidebarOpen} />
          <div
            style={{
              maxHeight: `calc(100vh - ${HEADER_HEIGHT}px)`,
            }}
            className={cn('w-full', !isSidebarOpen && 'md:ml-s')}
          >
            {children}
          </div>
        </div>
      </div>
    </div>
  )
}
